export enum VehicleUsageType {
  DELIVERY = "DELIVERY",
  PICKUP = "PICKUP"
}
